import React, { useState } from 'react';
import LogoutIcon from '../icons/logout';
import { Button, Image } from 'react-bootstrap';
import logo from '../../../assets/images/acumenVelocityLogo.svg';
import { MdTranslate } from 'react-icons/md';
import { LuFiles } from 'react-icons/lu';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

const TranslationLayout = ({ children }) => {
    const location = useLocation();
    const [showOptions, setShowOptions] = useState(false);
    const { user, portalId } = useAuth();
    const navigate = useNavigate();
    const handleMoreOptionsClick = () => {
        setShowOptions(!showOptions);
    };

    const handleLogout = () => {
        navigate(`/login/${portalId}`)
        localStorage.setItem('logout', true)
        localStorage.removeItem('driveAccessToken')
    };
    console.log("ldldldld", location.pathname.split('/')[1]);

    const recentsPath = ['recent-translations', 'preview-doc'];
    const translationsPath = ['translations'];


    return (
        <div className='d-flex flex-column ' style={{ backgroundColor: '#f5f5f5', height: '100%' }}>
            <div className='d-flex justify-content-between border-bottom-0' style={{ height: '4rem' }}>
                <div className='cursor_pointer d-flex gap-5 align-items-center mx-3' onClick={() => window.location.reload()}>
                    <Image alt='logo' src={logo} height={40} className='' />
                    <p className='name fs_16 fw_700'>Acumen Translation Hub</p>
                </div>
                <button type='btn' className='logout_translate mt-2 mx-4' onClick={() => handleMoreOptionsClick()}>
                    {user?.email && user.email.charAt(0).toUpperCase()}
                    {showOptions && (
                        <div className="position-relative">
                            <div
                                className="position-absolute gap-3 p-3"
                                style={{ left: "-8rem", zIndex: '100000000' }}
                            >
                                <div className="d-flex justify-content-end gap-3">
                                    <div className="card cursor_pointer" style={{ height: '3rem', width: '7rem' }}>
                                        <label className='cursor_pointer mt-2' onClick={handleLogout}>Logout  <LogoutIcon /></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </button>
            </div>
            <div className='d-flex' style={{ height: '100%' }}>
                <div className='pt-4' style={{ width: '5rem' }}>
                    <Button className={`leftbutton ${translationsPath.includes(location.pathname.split('/')[1]) ? "" : "bg-white text-black border"}`} onClick={() => navigate("/translations")}> <MdTranslate className="translation_sidebar_icon" /></Button>
                    <p>Translate</p>
                    <Button className={`leftbutton ${recentsPath.includes(location.pathname.split('/')[1]) ? "" : "bg-white text-black border"}`} onClick={() => navigate('/recent-translations')}> <LuFiles className="translation_sidebar_icon" /></Button>
                    <p>Recent</p>
                </div>
                <div className='rounded-5 w-100 overflow-auto' style={{ height: '100%' }}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default TranslationLayout;
